export default {"src":"/_next/static/media/enter_otp.86974798.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};